import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plan" }
const _hoisted_2 = { class: "plan__title" }
const _hoisted_3 = { class: "plan__title-text" }
const _hoisted_4 = { class: "plan__title-content" }
const _hoisted_5 = { class: "plan__title-btn btns btns--font-large" }
const _hoisted_6 = {
  key: 1,
  class: "subscription-error"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "plan-details" }
const _hoisted_10 = { class: "plan-details__top" }
const _hoisted_11 = { class: "plan-details__top-left" }
const _hoisted_12 = { class: "plan-details-name" }
const _hoisted_13 = { class: "plan-details__top-middle--show-desktop" }
const _hoisted_14 = { class: "plan-details__save" }
const _hoisted_15 = { class: "plan-details__save" }
const _hoisted_16 = { class: "plan-details__top-right" }
const _hoisted_17 = {
  key: 0,
  class: "plan-details__top-right-text"
}
const _hoisted_18 = {
  key: 1,
  class: "plan-details__top-right-text wg-no-translate"
}
const _hoisted_19 = {
  key: 0,
  class: "plan-details__bottom--hide-desktop"
}
const _hoisted_20 = { class: "plan-details__save" }
const _hoisted_21 = { class: "plan-details__save" }

import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import type { BillingView } from '@/models/billing'

import ChangeBillingPeriodPopup from './ChangeBillingPeriodPopup.vue'
import PlanDate from './BillingDataPaid.PlanDate.vue'
import { PlanChangeFailedError } from '@/services/cordova.purchase.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingDataPaid.PlanInfo.Monthly',
  props: {
    billing: {}
  },
  emits: ['subscribed'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const wait = useWait()
const emit = __emit

const popupAnnual = ref<InstanceType<typeof ChangeBillingPeriodPopup> | null>(
  null,
)

const error = ref<string | null>(null)

function switchAnnual(): void {
  popupAnnual.value?.show()
}

async function switchAnnualDirectly(): Promise<void> {
  error.value = null
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.annualPlan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (err) {
    if (err instanceof PlanChangeFailedError) {
      error.value = err.message
    }
    wait.end('Subscribing')
  }
}

async function reactivate(): Promise<void> {
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.plan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "plan__title-name" }, "Your Plan", -1)),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.billing.planName), 1)
      ]),
      _createElementVNode("div", null, [
        (__props.billing.allowPlanChange)
          ? (_openBlock(), _createBlock(_component_v_wait, {
              key: 0,
              for: "Subscribing"
            }, {
              waiting: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Processing... ", -1)),
                  _createVNode(_component_button_spinner)
                ])
              ]),
              default: _withCtx(() => [
                (__props.billing.cancel_at_period_end)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "plan__title-btn btns btns--font-large",
                      onClick: reactivate
                    }, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", null, " Reactivate ", -1)
                    ]))]))
                  : (__props.billing.is_trial)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "plan__title-btn btns btns--font-large",
                        onClick: switchAnnualDirectly
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("span", null, " Upgrade to Annual ", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "plan__title-btn btns btns--font-large",
                        onClick: switchAnnual
                      }, " Upgrade to Annual "))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (error.value !== null && error.value !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        _createVNode(ChangeBillingPeriodPopup, {
          ref_key: "popupAnnual",
          ref: popupAnnual,
          billing: __props.billing,
          targetPlan: __props.billing.annualPlan,
          title: "Change to Annual Subscription",
          confirmButtonText: "Change to Annual"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, " By changing to annual billing, you'll save " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "%. Wise choice!! ", 1),
            (__props.billing.billing_type === 'google')
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, " We'll charge you the annual price when your current subscription ends. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, " We'll charge you the annual price today, minus a credit for the time remaining on your monthly period. "))
          ]),
          _: 1
        }, 8, ["billing", "targetPlan"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "plan-details-title" }, "Details", -1)),
          _createElementVNode("p", _hoisted_12, _toDisplayString(__props.billing.plan.nickname) + " Plan", 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (__props.billing.is_trial)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "plan-details__switch",
                onClick: switchAnnualDirectly
              }, [
                _cache[5] || (_cache[5] = _createTextVNode("Switch to annual and ", -1)),
                _createElementVNode("span", _hoisted_14, "SAVE " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "%", 1)
              ]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "plan-details__switch",
                onClick: switchAnnual
              }, [
                _cache[6] || (_cache[6] = _createTextVNode("Switch to annual and ", -1)),
                _createElementVNode("span", _hoisted_15, "SAVE " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "%", 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_16, [
          (__props.billing.showPricesAfterDiscount)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "wg-no-translate" }, "$12/mo", -1),
                _createTextVNode(", then ", -1),
                _createElementVNode("span", { class: "wg-no-translate" }, "$24/mo", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(__props.billing.plan.price.withPeriod.perMonth), 1))
        ])
      ]),
      (__props.billing.allowPlanChange)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (__props.billing.is_trial)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "plan-details__switch",
                  onClick: switchAnnualDirectly
                }, [
                  _cache[8] || (_cache[8] = _createTextVNode("Switch to annual and ", -1)),
                  _createElementVNode("span", _hoisted_20, "SAVE " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "%", 1)
                ]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "plan-details__switch",
                  onClick: switchAnnual
                }, [
                  _cache[9] || (_cache[9] = _createTextVNode("Switch to annual and ", -1)),
                  _createElementVNode("span", _hoisted_21, "SAVE " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "%", 1)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(PlanDate, { billing: __props.billing }, null, 8, ["billing"])
  ]))
}
}

})